import MainMap from "../components/mainMap";
import "../App.css";

function HomePage() {
  return (
    <>
      <MainMap />
    </>
  );
}

export default HomePage;
